// @ts-nocheck

import { ThemeEvents } from "@theme/events";

if (!customElements.get("fbt-variant-change")) {
  class FBTUpdateTextWithMetafield extends HTMLElement {
    constructor() {
      super();

      // { "namespace": "custom", key: "ingredients" }
      this.config = JSON.parse(this.dataset.config);

      document.addEventListener(ThemeEvents.variantUpdate, async (e) => {
        const variantId = e.detail.resource.id;

        try {
          await this.getMetafield(variantId);

          if (this.metafield?.errors?.length > 0) {
            throw new Error(JSON.stringify(this.metafield.errors, null, 2));
          }

          const metafieldValue = this.metafield?.data?.node?.metafield?.value;

          this.closest("details.details")?.classList.toggle(
            "details--empty",
            !metafieldValue,
          );

          this.innerHTML = this.toHTML(JSON.parse(metafieldValue || null));
        } catch (error) {
          console.error(error);
          this.metafield = null;
          this.innerHTML = "Failed to get variant information";
        }
      });
    }

    async getMetafield(id) {
      const { token, version } = window.fbt.storefront;

      const response = await fetch(
        `https://${Shopify.shop}/api/${version}/graphql.json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": token,
          },
          body: JSON.stringify({
            query: `#graphql
              query {
                node (id: "gid://shopify/ProductVariant/${id}") {
                  ... on ProductVariant {
                    metafield(namespace: "${this.config.namespace}", key: "${this.config.key}") {
                      value
                    }
                  }
                }
              }
            `,
          }),
        },
      );

      if (!response.ok) {
        console.error("Network error");
      }

      const data = await response.json();
      this.metafield = data;
    }

    toHTML(node) {
      if (!node) return "";

      switch (node.type) {
        case "root":
          return node.children.map((child) => this.toHTML(child)).join("");

        case "paragraph":
          return `<p>${node.children.map((child) => this.toHTML(child)).join("")}</p>`;

        case "heading":
          return `<h${node.level}>${node.children
            .map((child) => this.toHTML(child))
            .join("")}</h${node.level}>`;

        case "text":
          return this.applyMarks(node);

        case "list":
          const tag = node.listType === "ordered" ? "ol" : "ul";
          return `<${tag}>${node.children
            .map((child) => this.toHTML(child))
            .join("")}</${tag}>`;

        case "list-item":
          return `<li>${node.children
            .map((child) => this.toHTML(child))
            .join("")}</li>`;

        case "link":
          return `<a href="${node.url}" target="_blank">
          ${node.children.map((child) => this.toHTML(child)).join("")}
        </a>`;

        default:
          return "";
      }
    }

    applyMarks(node) {
      let text = node.value || "";

      const marks = [
        {
          mark: 'bold',
          tag: 'strong'
        },
        {
          mark: 'italic',
          tag: 'em'
        }
      ]

      return marks.reduce((acc, { mark, tag }) => {
        if (!node[mark]) return acc;
        return `<${tag}>${acc}</${tag}>`;
      }, text);

      return text;
    }
  }

  customElements.define(
    "fbt-update-text-with-metafield",
    FBTUpdateTextWithMetafield,
  );
}
